import { loginRequest } from './authConfig';

export const handleEntraIdLogin = (instance: any) => {
    instance
        .loginRedirect({
            ...loginRequest,
            prompt: 'create',
        })
        .catch((error: any) => {
        });

};

export const handleEntraIdLogout = (instance: any) => {
    instance.logoutRedirect().then(() => {
        // Reload the page after logout redirect completes
        window.location.reload();
    }).catch((error: any) => {
    });
};
